import { render } from "./LoadingPlayer.vue?vue&type=template&id=52f21a43&scoped=true"
import script from "./LoadingPlayer.vue?vue&type=script&lang=js"
export * from "./LoadingPlayer.vue?vue&type=script&lang=js"

import "../../assets/css/loading/index.css?vue&type=style&index=0&id=52f21a43&scoped=true&lang=css"
import "./LoadingPlayer.vue?vue&type=style&index=1&id=52f21a43&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f21a43"]])

export default __exports__